export const childCompaniesPermissions = {
  CONFIGURATION_CHANGES: 'configurationChanges',
  CONFIGURATION_UPLOAD: 'configurationUpload',
  DEVICE_CONTROL: 'deviceControl',
  EXPERT_MODE: 'expertMode',
  OPERATIONAL_HISTORY: 'operationalHistory',
  RESTRICTED_CUSTOMER_DATA: 'restrictedCustomerData',
  FULL_CUSTOMER_DATA: 'fullCustomerData',
  CONTACT_READ: 'contactRead',
  CONTACT_WRITE: 'contactWrite',
  LOCATION_READ: 'locationRead',
  LOCATION_READ_APPROXIMATE: 'locationReadApproximate',
  LOCATION_WRITE: 'locationWrite',
  USER_MANAGEMENT: 'userManagement',
  SERVICE_SEQUENCES: 'serviceSequences',
}

export const companyPermissions = {
  COMPANY_ADMINISTRATION: 'companyAdministration',
  COMPANY_USER_MANAGEMENT: 'companyUserManagement',
  TEMPLATE_MANAGEMENT: 'templateManagement',
  NEW_PRODUCT_CATALOGUE: 'newProductManagement',
  BASE_PRODUCT_CATALOGUE: 'baseProductManagement',
  CAN_VIEW_SUBSCRIPTION_STATUS: 'canViewSubscriptionStatus',
  ...childCompaniesPermissions,
  TAG_MANAGEMENT: 'tagManagement',
  OTHER_COMPANIES_MANAGEMENT: 'otherCompaniesManagement',
}

export const permissions = {
  SUPER_ADMIN: 'superAdmin',
  COMPANY_CREATE_INVITE: 'companyCreateInvite',
  ...companyPermissions,
}
